<!-- Next arrow -->
<div class="next-wrap">
  <div class="full-next animate is-disabled">
     <a (click)="navigateTo()" href="#" id="navNext" data-cta="Next Arrow">
       <fa-icon [icon]="['fas', 'angle-down']"></fa-icon>
     </a>
  </div>
</div>
<!-- /Next arrow -->
